import React from "react";
import reactHtmlReplace from "react-html-replace";

import { MentionTag, LinkTag } from "components";
import { ILinkedCommunityDocuments } from "models";
import ReadMore from "components/ReadMore";

interface IUseReactHtmlReplace {
	text: string;
	linked_community_documents?: ILinkedCommunityDocuments[];
	words?: number;
	maxHeight?: string;
}

export const UseReactHtmlReplace = (props: IUseReactHtmlReplace) => {
	const { text, linked_community_documents, words = 60, maxHeight } = props;
	let htmlReplaceIndex = 0;

	if (!text) return null;

	// The rich editor (Quill) emits void tags that aren't self-closed
	// (e.g. `<img src="...">`, `<br>`), which react-html-replace can't parse
	// (it expects balanced/closed tags and throws "no matching tag"). Self-close
	// them so inline images and line breaks render instead of crashing/stripping.
	const html = text
		.replace(/<(img|br|hr|input|source|embed|col|area|wbr)\b([^>]*?)\s*\/?>/gi, "<$1$2 />");

	let rendered: React.ReactNode;
	try {
		rendered = reactHtmlReplace(
			html,
			(
				tag: string,
				attrs: {
					membermentionid?: string;
					href?: string;
					class?: string;
					tag?: string;
					id?: string;
				},
			) => {
				htmlReplaceIndex++;

				if (tag === "a") {
					const { membermentionid = undefined, href, id } = attrs;

					if (membermentionid) {
						return (
							<MentionTag
								key={`mention-tag-${membermentionid}-${htmlReplaceIndex}`}
								memberId={parseInt(membermentionid)}
							/>
						);
						// cssClass === "linkified"
					} else if (href) {
						return (
							<LinkTag
								key={`key-${href}-${htmlReplaceIndex}`}
								href={href}
								linked_community_documents={
									linked_community_documents
								}
								id={id}
							/>
						);
					}
				}
			},
		);
	} catch (e) {
		// react-html-replace requires perfectly balanced tags and throws
		// (e.g. "Invalid string, no matching tag 'p'") on some post HTML
		// produced by the rich editor. A single malformed post must never crash
		// the whole feed — fall back to plain text with line breaks preserved.
		rendered = text
			.replace(/<\/(p|div|li|h[1-6])>/gi, "\n")
			.replace(/<br\s*\/?>/gi, "\n")
			.replace(/<[^>]*>/g, "")
			.replace(/&nbsp;/gi, " ")
			.replace(/\n{3,}/g, "\n\n")
			.trim();
	}

	return (
		<ReadMore
			maxHeight={maxHeight}
			text={rendered}
			maxLines={words ? words : 50}
		/>
	);
};
